<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
#app {
  text-align: left;
  color: #343;
  word-break: inherit;
}
h1 {
  text-align: center;
  font-weight: normal;
  margin-block-start: 0.83em;
  margin-block-end: 0.83em;
  /* margin-block-start: 0.3em;
  margin-block-end: 0.3em; */
}
p {
  text-align: left;
  /* text-indent:2em; */
}
h2 {
  text-align: left;
  display: block;
  font-size: 1.5em;
  margin-block-start: 0.83em;
  margin-block-end: 0.83em;
  margin-inline-start: 0px;
  margin-inline-end: 0px;
  font-weight: bold;
}
.right {
  text-align: right;
  padding-right: 14px;
  padding-left: 14px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue